import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Icon } from "../icons";

export default function Dropdown({ label, items = [], icon }) {
  const [open, setOpen] = useState(false);
  const [panelPos, setPanelPos] = useState({ top: 0, left: 0, minWidth: 260 });
  const wrapRef = useRef(null);
  const btnRef = useRef(null);
  const navigate = useNavigate();

  function updatePosition() {
    if (!btnRef.current) return;
    const r = btnRef.current.getBoundingClientRect();
    setPanelPos({
      top: r.bottom + 6,
      left: r.left,
      minWidth: Math.max(260, r.width),
    });
  }

  useEffect(() => {
    const onDoc = (e) => {
      if (!wrapRef.current?.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("click", onDoc);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("click", onDoc);
      document.removeEventListener("keydown", onKey);
    };
  }, []);

  useEffect(() => {
    if (!open) return;
    updatePosition();
    const onScrollOrResize = () => updatePosition();
    window.addEventListener("scroll", onScrollOrResize, { passive: true });
    window.addEventListener("resize", onScrollOrResize);
    return () => {
      window.removeEventListener("scroll", onScrollOrResize);
      window.removeEventListener("resize", onScrollOrResize);
    };
  }, [open]);

  const onItemClick = (item) => {
    if (item.to) navigate(item.to);
    setOpen(false);
  };

  return (
    <div className="dropdown" ref={wrapRef}>
      <button
        className="dropdown-btn"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        ref={btnRef}
        title={label}
      >
        <Icon name={icon} className="menu-icon" />
        <span>{label}</span>
        <Icon name="caret" className="menu-caret" />
      </button>
      {open && (
        <div
          className="dropdown-panel"
          role="menu"
          style={{
            top: panelPos.top,
            left: panelPos.left,
            minWidth: panelPos.minWidth,
          }}
        >
          {items.map((it, idx) => {
            const item = typeof it === "string" ? { label: it } : it;
            return (
              <div
                key={idx}
                className="dropdown-item"
                role="menuitem"
                tabIndex={0}
                onClick={() => onItemClick(item)}
              >
                <Icon name={item.icon || "list"} className="item-icon" />
                <div className="item-label">{item.label}</div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
